import axios from './axios';

const getECommerceInfo = (currentLanguage) => {
  return axios.get('/api/store/eCommerceInfo', {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

export { getECommerceInfo };
